import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Reason } from '@/types/reason'

export function updateReason(body: Reason): Promise<AxiosResponse<Reason>> {
  return instance.put(`/reason/${body.uuid}`, body)
}
